import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { formatFullDate } from '../../Utills/utils';
import "./notifications.css";
import { clearAllNotifications } from "../../redux/notifications/notificationSlice";
import { openGlobalPopup } from "../../redux/action";
import ConfirmBox from "../../component/Popup/ConfirmBox";
import EmptyScreen from "../../component/common/EmptyScreen";


const notificationsData = [
  {
    id: 1,
    type: "order",
    title: "New Order",
    message: "Table 5 placed a new order",
    meta: "2 items · ₹420",
    time: "2 mins ago",
  },
  {
    id: 2,
    type: "order",
    title: "New Order",
    message: "Table 3 placed a new order",
    meta: "3 items · ₹680",
    time: "12 mins ago",
  },
  {
    id: 3,
    type: "table",
    title: "Table Update",
    message: "Table 7 status changed to Ready",
    time: "1 hour ago",
  },
  {
    id: 4,
    type: "payment",
    title: "Payment",
    message: "₹1,200 payment received for Table 10",
    time: "Today 11:30 AM",
  },
  {
    id: 5,
    type: "reservation",
    title: "Reservation",
    message: "New reservation for Table 12 at 7:30 PM",
    time: "Today 9:00 AM",
  },
  {
    id: 6,
    type: "info",
    title: "System Info",
    message: "System backup completed successfully",
    time: "Yesterday 4:15 PM",
  },
];

const Notifications = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("All");
  const [showClearConfirm, setShowClearConfirm] = useState(false);
  const notifications = useSelector(state => state.notifications?.list || []);

  const handleClearAll = () => {
    setShowClearConfirm(true);
    dispatch(openGlobalPopup("confirm-box"));
  };

  const filteredData =
    filter === "All"
      ? notifications
      : filter === "Takeaway"
        ? notifications.filter(n => n.type?.startsWith("TAKEAWAY_"))
      : notifications.filter(n => n.title === filter);

  return (
    <div className="notification-page">
      {/* Header */}
      <div className="notification-header">
        <h2>Notifications</h2>
        <button onClick={handleClearAll} className="clear-btn">Clear All</button>
      </div>

      {/* Filters */}
      <div className="notification-filter-tabs">
        {["All", "Takeaway", "New Order", "Waiter Request", "Reservations", "Payment"].map(tab => (
          <button
            key={tab}
            className={filter === tab ? "tab active" : "tab"}
            onClick={() => setFilter(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* List */}
      <div className="notification-list">
        {
          filteredData.length === 0 && (
            <EmptyScreen message="No notifications found" />
          )
        }
        {filteredData.map((item, index) => (
          <div key={index} className={`notification-card ${item.type}`}>
            <div className="notification-content">
              <h4>{item.title}</h4>
              <p>{item.message}</p>
              {item.meta && <span className="meta">{item.meta}</span>}
            </div>

            <div className="notification-right">
              {/* <button className="view-btn">View</button> */}
              <p className="time">{formatFullDate(item.time)}</p>
            </div>
          </div>
        ))}
      </div>
      <ConfirmBox
        title="Clear all notifications?"
        closeOnConfirm={true}
        onConfirm={() => {
          dispatch(clearAllNotifications());
          setShowClearConfirm(false);
        }}
        onCancel={() => {
          setShowClearConfirm(false);
        }}
      />
    </div>
  );
};

export default Notifications;
